<template>
  <div class="formS">
    <el-form ref="form" size="mini" :model="formData" label-width="80px" >

        <!--<el-row style="height:30px">
            <el-col :span="16" >
                <el-form-item label="流程名称">
                    <el-input v-model="formData.text"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6" style="text-align: right" >
            </el-col>
        </el-row>-->
        <el-form-item label="主表">
            <el-row style="height:30px">
            <el-col :span="9" >
            <el-input v-model="formData.mainTable"></el-input>
            </el-col>
            <el-col :span="3" style="text-align: right" >主键
            </el-col>
            <el-col :span="4" >

            <el-input v-model="formData.mainId"></el-input>
            </el-col>
                <el-col :span="7" style="text-align: right" >

                    <el-checkbox :true-label=1 :false-label=0 v-model="formData.i_sub" >子流程</el-checkbox>
                </el-col>

            </el-row>
        </el-form-item>
        <el-form-item label="子表.外键">
                    <el-input v-model="formData.subTable"></el-input>
        </el-form-item>
        <el-form-item label="流程类型">
            <el-row style="height:30px">
                <el-col :span="9" >
                    <el-select v-model="formData.vc_sptype" placeholder="请选择"  @change="setData">
                            <el-option
                                    v-for="(item,index) in typeList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_type"
                            ></el-option>


                    </el-select>
                </el-col>
                <el-col :span="3" style="text-align: right">分类
                </el-col>
                <el-col :span="4" >
                    <el-select v-model="formData.i_flowtype" placeholder="请选择"  @change="setData">
                        <el-option
                                v-for="(item,index) in flowtypeList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id"
                        ></el-option>


                    </el-select>
                </el-col>
<!--                <el-col :span="3" style="text-align: right" >标识-->
<!--                </el-col>-->
<!--                <el-col :span="4" >-->
<!--                    <el-input v-model="formData.vc_tag"></el-input>-->
<!--                </el-col>-->
            </el-row>
        </el-form-item>
        <el-tabs v-model="activelang" type="border-card" @tab-click="handleClick" class="mar-bottom18">
            <el-tab-pane v-for="lang in langList" :label="lang.vc_sort_name" :name="lang.i_id">
                <el-row class="margin-10">
                    <el-col :span="16" >
                        <el-form-item label="流程名称" class="margin-10b">
                            <el-input v-model="formData['text_' + lang.i_id]" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="display_flex" style="text-align: right" >
                        <span class=" tagCss flex1">标识</span><el-input class=" flex1" v-model="formData['vc_tag_' + lang.i_id]" size="mini"></el-input>

                    </el-col>
                </el-row>
<!--                <el-form-item  class="margin-10" label="流程简介">-->
<!--                    <el-input type="textarea" :rows="2" v-model="formData['jianjie_' + lang.i_id]"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item  class="margin-10b" label="流程详情">-->
<!--                    <el-input type="textarea" :rows="2" v-model="formData['desc_' + lang.i_id]"></el-input>-->
<!--                </el-form-item>-->
            </el-tab-pane>
        </el-tabs>
        <el-form-item label="流程简介">

            <el-input type="textarea" :rows="2" v-model="formData.jianjie"></el-input>
        </el-form-item>
        <el-form-item label="流程详情">

            <el-input type="textarea" :rows="2" v-model="formData.desc"></el-input>
        </el-form-item>
        <el-form-item label="数据">
            <!--          <div ref="params"></div>-->
            <div class="table-node ">
                <el-form v-for="(item,index) in  formData.params"  >
                    <el-row style="height:30px">
                        <el-col :span="4" >
                            <el-input v-model="item.key" class="feild" size="mini" ></el-input>
                        </el-col>
                        <el-col :span="10" >
                            <el-input v-model="item.field" class="feild" size="mini" ></el-input>
                        </el-col>
                        <el-col :span="6" >
                            <el-input v-model="item.tname" class="feild" size="mini" ></el-input>
                        </el-col>
                        <el-col  :span="3">
                            <el-select v-model="item.type" placeholder="数据类型" size="mini" class="feild" >
                                <el-option v-for="op in options" :label="op" :value="op">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col  :span="1">
                            <el-button v-if="index === 0" type="success" @click="addInput" icon="el-icon-plus"  class="button"></el-button>
                            <el-button v-if="index > 0" type="danger" @click="delInput( index)" icon="el-icon-minus"  class="button"></el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

        </el-form-item>



    </el-form>
  </div>
</template>
<script>
import * as flowUtil from '@/utils/logicFlowJs.js';
import {language} from '@/locales/selection'
export default {
  name: '',

  data() {
    return {
        formData:{ params: {},i_sub:0,mainTable:"",mainId:"",subTable:"",i_flowtype:0,vc_sptype:"",jianjie:'',desc:''},
        // formData:{ text: '未命名',params: {},i_sub:0,mainTable:"",mainId:"",subTable:"",i_flowtype:0,vc_sptype:"",vc_tag:'',jianjie:'',desc:''},
        dataSource:[{"tableName": "","主键":"i_id","tname":"", "type": "主表" },{"tableName": "","外键":"i_id","tname":"", "type": "子表" }],
        defData:[{"key": "id","field":"i_id","tname":"", "type": "Field" }],
        options:["Field","Sub","Ids","Param"],
        typeList:[],
        flowtypeList:[],
        langList:language,
        activelang:'zh_cn',
    }
  },
    watch: {
        langList: {
            handler(newList) {
                if (!newList || !newList.length) return;
                newList.forEach(lang => {
                    const id = lang.i_id;
                    // 只有当这些字段还不存在时，才初始化为空字符串
                    // 这样既能保证响应式，又不会覆盖掉接口返回的已有数据
                    if (this.formData['vc_tag_' + id] === undefined) {
                        this.$set(this.formData, 'vc_tag_' + id, '');
                    }
                    // if (this.formData['jianjie_' + id] === undefined) {
                    //     this.$set(this.formData, 'jianjie_' + id, '');
                    // }
                    // if (this.formData['desc_' + id] === undefined) {
                    //     this.$set(this.formData, 'desc_' + id, '');
                    // }
                    if (this.formData['text_' + id] === undefined) {
                        this.$set(this.formData, 'text_' + id, '');
                    }
                });
            },
            immediate: true // 关键：组件初始化时立即执行一次
        }
    },
  methods: {
      handleClick(tab, event) {
          // console.log(tab, event);
      },
    delInput(index){
      this.formData.params.splice(index, 1)
    },
    addInput(){
      this.formData.params.push({'key': '', 'type': 'Field'})
    },
    init(data){

        // const { params,text,i_sub,mainTable,mainId,subTable,vc_sptype,i_flowtype,vc_tag,desc,jianjie } = data;
        const { params,i_sub,mainTable,mainId,subTable,vc_sptype,i_flowtype,desc,jianjie} = data;
        this.langList.forEach(lang => {
            const id = lang.i_id;

            // 从 data 中提取对应语言的值，如果没有则默认为空字符串
            let textVal = data['text_' + id] || "";
            const tagVal = data['vc_tag_' + id] || "";
            // const descVal = data['desc_' + id] || "";
            // const jianjieVal = data['jianjie_' + id] || "";
            if(id=='zh_cn'){
                textVal = data['text_' + id] || "未命名"
            }else{
                textVal = data['text_' + id] || "Untitled"
            }
            // 使用 $set 确保 Vue 2 响应式（防止后端没返回该字段时视图不更新）
            this.$set(this.$data.formData, 'text_' + id, textVal);
            this.$set(this.$data.formData, 'vc_tag_' + id, tagVal);
            // this.$set(this.$data.formData, 'desc_' + id, descVal);
            // this.$set(this.$data.formData, 'jianjie_' + id, jianjieVal);
        });
        if (params) {
            this.formData.params = params;

        }
        else
        {this.formData.params = this.defData;}
        // if (text_zh_cn ) {
        //     this.$data.formData.text_zh_cn = textVal
        // }
        // else
        // {this.formData.text_zh_cn = "未命名";}
        if (i_sub ) {
            this.$data.formData.i_sub = i_sub
        }
        else
        {this.formData.i_sub = 0;}
        this.$data.formData.mainTable=mainTable?mainTable:"";
        this.$data.formData.mainId=mainId?mainId:"";
        this.$data.formData.subTable=subTable?subTable:"";
        this.$data.formData.vc_sptype=vc_sptype?vc_sptype:"";
        this.$data.formData.i_flowtype=i_flowtype?i_flowtype:0;
        // this.$data.formData.vc_tag=vc_tag?vc_tag:"";
        this.$data.formData.jianjie=jianjie?jianjie:"";
        this.$data.formData.desc=desc?desc:"";
        this.loadFlowSpType();
        this.loadFlowType();
    },
    getData(){
          return this.formData;
      },
      //loadFlow模板
      async loadFlowSpType() {
            let _this=this;
          let param = {};
          let res = await flowUtil.getFlowSpType(param);
          if (res.code == 1) {
              this.$data.typeList= res.data;

          } else {
              this.$message.error(res.message);
          }
      },
      async loadFlowType() {
          let _this=this;
          let param = {};
          let res = await flowUtil.getFlowType(param);
          if (res.code == 1) {
              this.$data.flowtypeList= res.data;

          } else {
              this.$message.error(res.message);

          }
      },
      setData(){

          this.$emit('infoedit',this.formData) ;
      }
}
}
</script>
<style scoped>
  .feild {
    height: 20px;
    width:100%;
    line-height: 20px;
    font-size: 10px;
    display: flex;
    border: none;
    padding: 0 0px;
  }

  .button {
    height: 20px;
    width:20px;
    line-height: 25px;
    font-size: 8px;
    display: flex;
    border: none;
    padding: 5px;
  }.table-container {
       padding: 10px;
       box-sizing: border-box;

   }
  .table-node {
      width: calc(100% -80 );
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
      margin: 0px;
      overflow-y: auto;
      height:250px;
  }
  .table-node::before {
      content: "";
      display: block;
      width: 100%;
      height: 8px;
      background: #d79b00;
  }
  .table-node.table-color-1::before {
      background: #9673a6;
  }
  .table-node.table-color-2::before {
      background: #dae8fc;
  }
  .table-node.table-color-3::before {
      background: #82b366;
  }
  .table-node.table-color-4::before {
      background: #f8cecc;
  }
  .table-name {
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #f5f5f5;
      font-size: 14px;
  }
  .table-feild {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
  }
  .feild-type {
      color: #9f9c9f;
  }
  .set_pop_lay {
      position: absolute;
      margin: 0;
      padding: 0;
      left:calc(100% - 325px);
      width: 300px;
      color: #774917;
      background: #f5f5f5;
      height: 400px;
      opacity: 0.8;
      overflow: hidden;
  }
  .display_flex{
      display: flex;
  }
  .flex1{
      flex: 1;
  }
    .tagCss{
        display: inline-block;
        font-size: 13px;
    }
  .margin-10{
        margin:0 -13px -13px -13px ;
    }
  .margin-10b{
        margin:0px 0px -13px 0px ;
    }
  /deep/ .el-form-item__label{
        font-size: 13px !important;
    }
  .mar-bottom18{
      margin-bottom: 18px;
  }
</style>
